import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'VVAD';

  constructor(router: Router) {
    const navEndEvent$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      console.log('e.urlAfterRedirects', e.urlAfterRedirects);
      gtag('config', 'UA-22523699-1', { 'page_path': e.urlAfterRedirects });
    });

  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts